import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const depositSchema = z.object({
  /** Currency */
  ccy: z.string(),
  /** Chain name */
  chain: z.string(),
  /** Deposit amount */
  amt: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Deposit account */
  from: z.string(),
  /** If from is a phone number, this parameter return area code of the phone number */
  areaCodeFrom: z.string(),
  /** Deposit address */
  to: z.string(),
  /** Hash record of the deposit */
  txId: z.string(),
  /** The timestamp that the deposit record is created, Unix timestamp format in milliseconds */
  ts: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
  /** Status of deposit
   * - 0: waiting for confirmation
   * - 1: deposit credited
   * - 2: deposit successful
   * - 8: pending due to temporary deposit suspension on this crypto currency
   * - 11: match the address blacklist
   * - 12: account or deposit is frozen
   * - 13: sub-account deposit interception
   * - 14: KYC limit
   */
  state: z.union([
    z.literal('0'),
    z.literal('1'),
    z.literal('2'),
    z.literal('8'),
    z.literal('11'),
    z.literal('12'),
    z.literal('13'),
    z.literal('14'),
  ]),
  /** Deposit ID */
  depId: z.string(),
  /** Internal transfer initiator's withdrawal ID */
  fromWdId: z.string(),
  /** The actual amount of blockchain confirmed in a single deposit */
  actualDepBlkConfirm: z.string(),
})

export type Deposit = z.infer<typeof depositSchema>
